import {InjectionToken} from "@angular/core";
import {SchedulerLike} from "rxjs";

export const LOCATION_TOKEN = new InjectionToken('window location object');
export const SECONDARY_LOCATION_TOKEN = new InjectionToken('Secondary window location object');
export const WINDOW_TOKEN = new InjectionToken('window object');
export const SCHEDULER_TOKEN = new InjectionToken<SchedulerLike>('scheduler token');
